export default {
  "hero_title": "Kakobuy Spreadsheet Poland – The Largest Database of Best Kakobuy Products",
  "hero_subtitle": "Find verified links, best products, sneakers, streetwear and up-to-date Kakobuy Spreadsheet listings in one place.",
  "cta_spreadsheet": "🔥 Check the Latest Kakobuy Spreadsheet",
  "cta_buy_now": "Buy Now on Kakobuy",
  "trust_updated": "Updated product lists",
  "trust_guides": "Guides for Poland",
  "trust_compare": "Shopping comparisons",
  "trust_safety": "User safety",
  "what_is_title": "What is Kakobuy Spreadsheet?",
  "what_is_content": "Kakobuy Spreadsheet is an organized product database that helps users quickly find the best deals, shopping links and popular products from China. With a clear spreadsheet format, you can compare prices, quality and reviews of thousands of products in seconds – from sneakers to streetwear clothing, accessories and electronics.",
  "how_it_works_title": "How it works?",
  "step1_title": "Find a product",
  "step1_desc": "Browse categories and find products from China that interest you.",
  "step2_title": "Check Kakobuy Spreadsheet",
  "step2_desc": "Use ready-made spreadsheets with links and compare offers.",
  "step3_title": "Compare quality and price",
  "step3_desc": "Check ratings, reviews and QC photos before buying.",
  "step4_title": "Buy via Kakobuy",
  "step4_desc": "Place your order through the trusted Kakobuy platform.",
  "categories_title": "Kakobuy Spreadsheet Categories",
  "categories_subtitle": "Choose a category and discover the best products in our spreadsheets",
  "comparison_title": "Kakobuy Spreadsheet vs Traditional Search",
  "comparison_col1": "Kakobuy Spreadsheet",
  "comparison_col2": "Traditional Search",
  "comparison_feature": "Feature",
  "comparison_links": "Ready-made links",
  "comparison_categories": "Product categories",
  "comparison_time": "Time saving",
  "comparison_beginners": "For beginners",
  "safety_title": "Is Kakobuy Spreadsheet Safe?",
  "safety_content": "Our website is an independent information guide. We do not sell products and we do not handle payments. Kakobuy Spreadsheet is solely a tool to help you search and compare products.",
  "safety_tip1": "Check the seller before purchasing",
  "safety_tip2": "Read reviews from other buyers",
  "safety_tip3": "Always check QC photos",
  "safety_tip4": "Verify shipping information",
  "article_link": "Read our complete Kakobuy Spreadsheet guide",
  "articles_title": "Kakobuy Articles & Guides",
  "articles_subtitle": "Discover our detailed guides and SEO articles that help you shop safely and cheaply through Kakobuy",
  "article_read_more": "Read more",
  "footer_description": "Kakobuy Poland Spreadsheet Hub – Your independent guide to the best Kakobuy products, spreadsheets and tutorials for Polish buyers.",
  "footer_privacy": "Privacy Policy",
  "footer_disclaimer": "Disclaimer",
  "footer_about": "About Us",
  "footer_rights": "© 2026 Kakobuy Poland Spreadsheet Hub. All rights reserved.",
  "footer_disclaimer_text": "This site is an independent information guide and is not affiliated with Kakobuy. All trademarks belong to their respective owners.",
  "nav_home": "Home",
  "nav_guide": "Shopping Guide",
  "nav_article": "Guide",
  "dropdown_placeholder": "Select product category",
  "category_shoes": "Shoes",
  "category_hoodies": "Hoodies/Sweaters",
  "category_tshirts": "T-Shirts",
  "category_jackets": "Jackets",
  "category_pants": "Pants/Shorts",
  "category_headwear": "Headwear",
  "category_sets": "Sets",
  "category_underwear": "Underwear",
  "category_jersey": "Jersey",
  "category_accessories": "Accessories",
  "category_bags": "Bags",
  "category_belts": "Belts",
  "category_perfumes": "Perfumes",
  "category_other": "Other Stuff"
}